/**
 * Badge component
 * Simple badge component using Tailwind CSS
 */

import React from 'react'
import { cn } from '@/lib/utils'

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?:
    | 'default'
    | 'secondary'
    | 'destructive'
    | 'outline'
    | 'success'
    | 'warning'
    | 'muted'
    | 'pending'
}

const variantStyles: Record<string, React.CSSProperties> = {
  default: { backgroundColor: '#3b82f6', color: 'white' },
  secondary: { backgroundColor: '#f3f4f6', color: '#111827' },
  destructive: { backgroundColor: '#ef4444', color: 'white' },
  outline: { border: '1px solid #d1d5db', color: '#374151', backgroundColor: 'transparent' },
  success: { backgroundColor: '#10b981', color: 'white' },
  warning: { backgroundColor: '#f59e0b', color: 'white' },
  muted: { backgroundColor: 'var(--surface-alt, #e5e7eb)', color: 'var(--text-muted, #374151)' },
  pending: { backgroundColor: '#0ea5e9', color: 'white' },
}

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = 'default', style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('tagp-badge', className)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '9999px',
          padding: '2px 10px',
          fontSize: '12px',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          ...variantStyles[variant],
          ...style,
        }}
        {...props}
      />
    )
  }
)
Badge.displayName = 'Badge'
